import { HttpClient, HttpHeaders } from "@angular/common/http";
import { timeout } from "rxjs/operators";
import { ResponseData, Paginador } from "../../Model/Base/Response";
import { AuthService } from "../Interceptor/auth.service";
import { SessionStorageService } from "../sessionStorageService/session-storage.service";

export class BaseService {
  Component: string;

  constructor(public http: HttpClient, public lsService: SessionStorageService, private readonly authService: AuthService) { }

  private createBodySender(data: any, Page: Paginador = null): any {
    let userAccess = JSON.parse(this.lsService.getLSItem("ResponseData"));
    let request = JSON.stringify(data);
    return {
      ObjectRequest: request,
      component: this.Component,
      status: 100,
      Paginator: Page,
      user: userAccess?.preferred_username != undefined ? userAccess?.preferred_username : userAccess?.email
    };
  }

  public createHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': "0",
    });
  }

  public async PostData(data: any, api: string, method: string, Page: Paginador = null) {
    let DatoResponse: ResponseData;
    const BodySender = this.createBodySender(data, Page);
    const headers = this.createHeaders();

    await this.http
      .post<ResponseData>(
        window.location.origin + "/api/" + api + "/" + method,
        BodySender, { headers: headers }
      ).pipe(timeout(60000 * 15))
      .toPromise()
      .then((res) => {
        // Success
        DatoResponse = res;
      })
      .catch((err) => {
        // error
        DatoResponse = err;
      });
    return DatoResponse;
  }
}
